import axios from 'axios';

const baseApiUrl = 'api/docx';

export default class DocxService {
  public downloadStemdoerDocx(stemdoerId: string, h?: boolean): Promise<Blob> {
    return new Promise<Blob>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/stemdoer/${stemdoerId}`, { params: { h }, responseType: 'blob' })
        .then((res: { data: Blob }) => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public handleDocxDownload(fileName: string, data: Blob): void {
    const url = URL.createObjectURL(data);
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.setAttribute('download', fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(url);
  }
}
